var app = angular.module("leonardo");

var UnDeleteUnitDialog = function($scope, UnitService) {
  $scope.unit = $scope.ngDialogData.unit;

  $scope.undelete = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      return;
    }
    UnitService.unDeleteAll({id: $scope.unit.id}).then(function(data) {
      $scope.confirm(data);
    }, function () {
      $scope.closeThisDialog();
    });
  };

};

app.controller('UnDeleteUnitDialog', ['$scope', 'UnitService', UnDeleteUnitDialog]);
